import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";

import {
	HeatAgeThreshold,
	HeatAgeThresholdDraft,
} from "../models/HeatAgeThreshold";

export const getHeatAgeThresholds = async (signal?: AbortSignal) => {
	const apiService = new MESApiService();

	const resp = await apiService.callV2(
		"[LAB].[GetHeatAgeThresholds]",
		[],
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as HeatAgeThreshold[];
	}
	throw new Error(resp.message || "Error fetching heat age thresholds");
};

export const upsertHeatAgeThresholds = async (
	rows: HeatAgeThresholdDraft[],
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "Rows", value: JSON.stringify(rows) },
	];

	const resp = await apiService.callV2(
		"[LAB].[UpsertHeatAgeThresholds]",
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error saving heat age thresholds");
	}
};
